export function SAVE_BEGIN_DATE(state, [begin_date]){
    state.begin_date = begin_date
}

export function SAVE_END_DATE(state, [end_date]){
    state.end_date = end_date
}